<button
  type="button"
  class="sidebar-brand btn border-0 bg-transparent d-flex align-items-center gap-2 mb-0 px-1 py-0 me-auto text-start"
  @click="$emit('brand-click')"
  aria-label="Open Siyanda Platinum overview"
>

  <!-- Short Logo -->
  <div class="sidebar-logo rounded-3"></div>


  <!-- Brand Title + Subtitle -->
  <div class="sidebar-brand-copy d-flex flex-column">
    <p class="brand-title text-dark text-uppercase fw-bold text-xs mb-1">{{ title }}</p>
    <p class="brand-subtitle text-secondary text-uppercase fw-semibold text-xxs mb-0">{{ subtitle }}</p>
  </div>

</button>
